<div class="signup">
  <h1>Cadastro NCommerce</h1>

  @if (onPhone && stage !== 'invalid' && stage !== 'loading') {
    <p class="warning">Você está no celular. Pode preencher o cadastro por aqui, mas a instalação precisa ser feita
      <strong>no computador onde o NCommerce vai ficar</strong>. No fim, mostramos um código para usar nele.</p>
  }
  @if (onMac && stage !== 'invalid' && stage !== 'loading' && stage !== 'done') {
    <p class="warning">Ainda não temos suporte para computadores Apple. Para instalar o NCommerce, use um computador
      com Ubuntu 26 ou mais recente, ou com Windows 11.</p>
  }

  @switch (stage) {
    @case ('loading') {
      <p class="text-center">Carregando...</p>
    }

    @case ('invalid') {
      <div class="card-form">
        <p class="error">{{ error }}</p>
        <a class="btn btn-primary" routerLink="/cadastro">Pedir um novo link</a>
      </div>
    }

    @case ('account') {
      <div class="card-form">
        <h2>Olá, {{ lead?.name }}! Crie sua conta</h2>
        <p class="fine">É com ela que você entra no portal do NCommerce. Ela não é o usuário do sistema da loja.</p>
        <app-google-button (credential)="googleAccount($event)"></app-google-button>
        <p class="or">ou com e-mail e senha</p>
        <form (ngSubmit)="createAccount()">
          <label class="form-label" for="acc-email">E-mail</label>
          <input id="acc-email" class="form-control" name="email" type="email" [(ngModel)]="email" autocomplete="email">
          <label class="form-label" for="acc-password">Senha (mínimo 6 caracteres)</label>
          <input id="acc-password" class="form-control" name="password" type="password" [(ngModel)]="password" autocomplete="new-password">
          <label class="form-label" for="acc-confirm">Confirme a senha</label>
          <input id="acc-confirm" class="form-control" name="password_confirmation" type="password" [(ngModel)]="passwordConfirmation" autocomplete="new-password">
          <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="loading">{{ loading ? 'Criando...' : 'Criar conta' }}</button>
        </form>
        @if (error) { <p class="error">{{ error }}</p> }
      </div>
    }

    @case ('login') {
      <div class="card-form">
        <h2>Entre na sua conta</h2>
        <p class="fine">Este cadastro já tem uma conta. Entre para continuar de onde parou.</p>
        <app-google-button (credential)="googleAccount($event)"></app-google-button>
        <p class="or">ou com e-mail e senha</p>
        <form (ngSubmit)="signIn()">
          <label class="form-label" for="login-email">E-mail</label>
          <input id="login-email" class="form-control" name="email" type="email" [(ngModel)]="email" autocomplete="email">
          <label class="form-label" for="login-password">Senha</label>
          <input id="login-password" class="form-control" name="password" type="password" [(ngModel)]="password" autocomplete="current-password">
          <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="loading">{{ loading ? 'Entrando...' : 'Entrar' }}</button>
        </form>
        @if (error) { <p class="error">{{ error }}</p> }
      </div>
    }

    @case ('done') {
      <div class="card-form">
        <h2>Cadastro concluído!</h2>
        <p><strong>{{ result?.company?.nome_fantasia }}</strong> está pronta para instalar.</p>
        @if (result?.payment_pending) {
          <p class="warning">Você escolheu o Plano {{ plan(result?.plan)?.name }}. Você só paga depois de instalar: quando
            o sistema estiver funcionando e com o acesso remoto ligado, mandamos o link de pagamento para o seu e-mail e
            WhatsApp.</p>
        }
        <p>Código de instalação:</p>
        <div class="code">{{ result?.install_code }}</div>
        <p class="fine text-center">Vale até {{ result?.expires_at | date:'dd/MM HH:mm' }} e só pode ser usado em um computador.</p>

        @if (onPhone) {
          <p>No computador onde o NCommerce vai ficar, abra <strong>ncommerce.app/instalar</strong> e digite o código acima.</p>
        } @else {
          <a class="btn btn-success btn-lg" [href]="downloadUrl()">Baixar o instalador</a>
          <app-install-steps></app-install-steps>
        }
        <p class="fine text-center">Veja e mude o seu plano a qualquer momento na <a routerLink="/cliente">Área do Cliente</a>.</p>
        <button class="btn btn-link" type="button" (click)="newEstablishment()">Cadastrar outro estabelecimento</button>
      </div>
    }
  }

  @if (inWizard()) {
    <ol class="progress-steps">
      @for (s of steps; track s.stage) {
        <li [class.active]="stage === s.stage" [class.done]="stage !== s.stage && stepDone(s.stage)"
          [style.cursor]="canOpen(s.stage) ? 'pointer' : 'default'" (click)="goTo(s.stage)">{{ s.label }}</li>
      }
    </ol>

    @switch (stage) {
      @case ('company') {
        <form class="card-form" (ngSubmit)="saveCompany()">
          <h2>Seu estabelecimento</h2>
          <p class="fine">O cadastro é só para empresas com CNPJ (MEI também tem).</p>
          <label class="form-label" for="c-fantasia">Nome do estabelecimento</label>
          <input id="c-fantasia" class="form-control" name="nome_fantasia" [(ngModel)]="company.nome_fantasia" placeholder="Ex.: Pizzaria do Zé">
          <label class="form-label" for="c-razao">Razão social</label>
          <input id="c-razao" class="form-control" name="razao_social" [(ngModel)]="company.razao_social">
          <label class="form-label" for="c-cnpj">CNPJ</label>
          <input id="c-cnpj" class="form-control" name="cnpj" [(ngModel)]="company.cnpj" mask="00.000.000/0000-00" placeholder="00.000.000/0000-00">
          <label class="form-label" for="c-address">Endereço</label>
          <input id="c-address" class="form-control" name="address" [(ngModel)]="company.address" placeholder="Rua, número">
          <label class="form-label" for="c-district">Bairro</label>
          <input id="c-district" class="form-control" name="district" [(ngModel)]="company.district">
          <label class="form-label" for="c-city">Cidade</label>
          <input id="c-city" class="form-control" name="city" [(ngModel)]="company.city">

          <label class="form-label">Qual o sistema do computador onde o NCommerce vai ficar?</label>
          <div class="choices">
            @for (os of operatingSystems; track os.key) {
              <label [class.selected]="company.computer_os === os.key">
                <input type="radio" name="computer_os" [value]="os.key" [(ngModel)]="company.computer_os">
                <span>{{ os.label }}<small>{{ os.hint }}</small></span>
              </label>
            }
          </div>

          @switch (company.computer_os) {
            @case ('mac') {
              <p class="error">Ainda não temos suporte para computadores Apple. Conclua o cadastro em um computador com
                Ubuntu 26 ou mais recente, ou com Windows 11.</p>
            }
            @case ('ubuntu') {
              <div class="check-pc">
                <p><strong>Confira o computador.</strong> Ele precisa de Ubuntu 20.04 ou mais recente (recomendamos o 26),
                  pelo menos 4 processadores e 4 GB de memória.</p>
                <p>Abra o Terminal (Ctrl+Alt+T), cole o comando abaixo e tecle Enter:</p>
                <pre>{{ ubuntuCheck }}</pre>
                <p class="fine">Um computador com 4 GB mostra um pouco menos, como 3,7 GB. Isso está certo.</p>
              </div>
            }
            @case ('') { }
            @default {
              <div class="check-pc">
                <p><strong>Confira o computador.</strong> Aperte as teclas <kbd>Windows</kbd> + <kbd>R</kbd>, digite
                  <code>msinfo32</code> e tecle Enter. Na janela que abrir, confira:</p>
                <ul>
                  <li><strong>Nome do SO:</strong> Windows 10 ou Windows 11;</li>
                  <li><strong>Versão:</strong> o número depois de "Compilação" precisa ser 19045 ou maior;</li>
                  <li><strong>Processador:</strong> pelo menos 4 "processador(es) lógico(s)";</li>
                  <li><strong>Memória física (RAM) instalada:</strong> 6 GB ou mais.</li>
                </ul>
              </div>
            }
          }

          <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="loading || company.computer_os === 'mac'">
            {{ loading ? 'Salvando...' : 'Continuar' }}
          </button>
          @if (error) { <p class="error">{{ error }}</p> }
        </form>
      }

      @case ('plan') {
        <div class="card-form">
          <h2>Escolha o plano</h2>
          @if (progress?.chosen_plan && progress?.chosen_plan !== 'free') {
            <p class="fine">Mostramos o plano que você escolheu e os maiores. Depois, você pode mudar de plano na
              <a routerLink="/cliente">Área do Cliente</a>.</p>
          }
          <div class="plans">
            @for (p of progress?.plans; track p.key) {
              <button type="button" class="plan" [class.selected]="selectedPlan === p.key" (click)="selectedPlan = p.key">
                <app-plan-card [plan]="p"></app-plan-card>
              </button>
            }
          </div>
          <div class="actions">
            <button class="btn btn-outline-secondary" type="button" (click)="goTo('company')">Voltar</button>
            <button class="btn btn-primary" type="button" [disabled]="loading || !selectedPlan" (click)="savePlan()">
              {{ loading ? 'Salvando...' : 'Continuar' }}
            </button>
          </div>
          @if (error) { <p class="error">{{ error }}</p> }
        </div>
      }

      @case ('personal') {
        <form class="card-form" (ngSubmit)="savePersonal()">
          <h2>Seus dados</h2>
          <p class="fine">Do responsável pelo estabelecimento, para o contrato.</p>
          <label class="form-label" for="p-name">Nome completo</label>
          <input id="p-name" class="form-control" name="name" [(ngModel)]="personal.name" autocomplete="name">
          <label class="form-label" for="p-cpf">CPF</label>
          <input id="p-cpf" class="form-control" name="cpf" [(ngModel)]="personal.cpf" mask="000.000.000-00" placeholder="000.000.000-00">
          <label class="form-label" for="p-whatsapp">WhatsApp</label>
          <input id="p-whatsapp" class="form-control" name="whatsapp" [(ngModel)]="personal.whatsapp" mask="(00) 0000-0000||(00) 0 0000-0000" autocomplete="tel">
          <div class="actions">
            <button class="btn btn-outline-secondary" type="button" (click)="goTo('plan')">Voltar</button>
            <button class="btn btn-primary" type="submit" [disabled]="loading">{{ loading ? 'Salvando...' : 'Continuar' }}</button>
          </div>
          @if (error) { <p class="error">{{ error }}</p> }
        </form>
      }

      @case ('contract') {
        <div class="card-form">
          <h2>Contrato</h2>
          <p>{{ company.nome_fantasia }} · Plano {{ plan(selectedPlan)?.name }}</p>
          <div class="contract-text">{{ progress?.contract?.text }}</div>
          <label class="mt-2">
            <input type="checkbox" [(ngModel)]="accepted">
            Li e aceito o contrato, os <a routerLink="/termos" target="_blank">Termos de Uso</a> e a
            <a routerLink="/privacidade" target="_blank">Política de Privacidade</a>.
          </label>
          <div class="actions">
            <button class="btn btn-outline-secondary" type="button" (click)="goTo('personal')">Voltar</button>
            <button class="btn btn-success" type="button" [disabled]="loading || !accepted" (click)="accept()">
              {{ loading ? 'Concluindo...' : 'Aceitar e concluir' }}
            </button>
          </div>
          @if (error) { <p class="error">{{ error }}</p> }
        </div>
      }
    }

    <p class="fine text-center">
      Conectado como {{ progress?.owner?.email }} ·
      <button class="btn btn-link btn-sm p-0 align-baseline" type="button" (click)="signOut()">sair</button>
    </p>
  }
</div>
